/**
 * `true` quando o navegador suporta Background Sync API (Chrome Android,
 * Chrome Desktop). `false` em iOS Safari e navegadores legados, onde o
 * fallback de polling (CA-06) deve ser usado — Spec Técnica > Migração do
 * Service Worker, item 3.
 */
export function isBackgroundSyncSupported(): boolean {
  return 'serviceWorker' in navigator && 'sync' in ServiceWorkerRegistration.prototype;
}
